// app/javascript/controllers/sentinel_tracking_controller.js
import { Controller } from "@hotwired/stimulus"
import ahoy from "../ahoy_config"

export default class extends Controller {
  connect() {
    ahoy.track("Sentinel Viewed", {
      path: window.location.pathname,
      // Add any other context here if needed
    });
  }
}
